export function getMenuCategoryOptions(items = []) {
  return [
    "All",
    ...new Set(items.map((item) => item.category).filter((name) =>
      typeof name === "string" && name.trim() !== "" && name !== "All"
    )),
  ];
}

export function filterMenuItems(items, {
  selection = "Food",
  type = "All",
  category = "All",
  search = "",
} = {}) {
  const term = String(search);
  const lowerCaseTerm = term.toLowerCase();
  return items.filter((item) =>
    (selection !== "Food" || type === "All" || item.type === type) &&
    (category === "All" || item.category === category) &&
    (!term || String(item.name ?? "").toLowerCase().includes(lowerCaseTerm) ||
      String(item.code ?? "").includes(term))
  );
}
